import PropTypes from 'prop-types'
import React     from 'react'
import { Link }  from 'react-router-dom'

import { NavLink                                    } from 'alto-react-components/lib/components'
import { link, prefix, login, registrationNavLinkTo } from 'alto-react-base-auth/lib/routes'
import { generalProfileSetting, generalRegistrationSetting } \
  from 'alto-react-client-auth/lib/settings'

export * from 'alto-react-base-auth/lib/routes'

export contactForm           = prefix + '/contact_form'
export profile               = prefix + '/profile'
export cardNumberForm        = prefix + '/registration/card_number'
export basicRegistration     = prefix + '/registration/basic'
export registrationWithBV    = prefix + '/registration/with_bv'
export registrationWithoutBV = prefix + '/registration/without_bv'

export ProfileNavLink = (props, context) ->
  profileSetting     = generalProfileSetting(context.settings)
  profileEditAllowed = (profileSetting.enabled and context.auth.isClient)
  profileCaption     = if profileEditAllowed then 'Profil' else 'Změnit heslo'

  <NavLink id="profile-link" to={profile}>{profileCaption}</NavLink>

ProfileNavLink.contextTypes = { auth: PropTypes.object, settings: PropTypes.object }

export RegisterNavLink = (props, context) ->
  registrationNavLinkTo({...props, to: cardNumberForm}, context)

RegisterNavLink.contextTypes = { settings: PropTypes.object }

export ContactFormLink = link(contactForm)
